// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3nd9O","options":"AnswerScale_options__dVKnO","selected":"AnswerScale_selected__3ghRu"};